import {fetchWithToken} from "./fetchWithToken";
import {DemoDispatch} from "../model/DemoDispatch";

const getBaseUrl = (customerId: string) => {
    let url;
    switch (process.env.NODE_ENV) {
        case 'production':
            url = `/api/customers/${customerId}/dispatches/demo`;
            break;
        case 'development':
            url = `http://localhost:5000/api/customers/${customerId}/dispatches/demo`;
            break;
        default:
            url = `/api/customers/${customerId}/dispatches/demo`;
    }

    return url;
}

export async function getDemoDispatches(customerId: string): Promise<DemoDispatch[]> {
    try {
        const response = await fetchWithToken(getBaseUrl(customerId), {
            method: "GET",
        });

        if (!response.ok) {
            throw new Error("Error while loading demo dispatches");
        }

        return await response.json();
    } catch (error) {
        throw new Error("Error while loading demo dispatches");
    }
}

